module.exports = __webpack_public_path__ + "68e1ce3359df0808db9cc34dcb488c4b.svg";